import { IChildProp } from "@intelligence/components/Form/type";
import { convertDataSourceAndSource } from "@intelligence/_config/enumeration/dataSource";

const PC_METRICS_TABLE_DATA_SOURCE = {
  mscience: ['digitalRevenue', 'units', 'digitalARPPU', 'ast'],
  gsd: ['digitalUnitsGSD', 'physicalUnitsGSD', 'digitalRevenueGSD', 'physicalRevenueGSD'],
  npd: ['physicalRevenue', 'physicalUnits'],
  databrain: ['mau', 'playerShare', 'mauGrowth', 'mauNew', 'mauReturning', 'lifetimePlayer', 'timeSpent0h','timeSpent1h', 'timeSpent5h', 'timeSpent10h', 'timeSpent25h', 'timeSpent50h', 'avgDailyPlaytime', 'avgDailySessions', 'avgPlaytimePerSession', 'avgMonthlyPlaytime', 'avgMonthlySessions', 'avgDaysPlayed', 'stickness', 'totalHours', 'churn', 'acquisition', 'retentionD1', 'retentionD2', 'retentionD4', 'retentionD7', 'retentionD14', 'retentionD28'],
};

const getMetricsChildren = () => convertDataSourceAndSource(PC_METRICS_TABLE_DATA_SOURCE, {
  disableCondition: {
    gsd: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
    npd: 'additionalFields:dateType:daily||additionalFields:dateType:weekly',
    databrain: 'additionalFields:dateType:daily||additionalFields:dateType:weekly',
  },
  disableMsgKey: {
    gsd: 'dbi_info_gsd_metrics_category_disabled_tips',
    npd: 'dbi_info_physical_monthly_only',
    databrain: 'dbi_info_newzoo_bymonth',
  },
  // 默认权限，convertDataSourceAndSource会过滤禁选的选项
  isDefault: {
    mscience: ['digitalRevenue', 'units', 'ast'],
    gsd: 'all',
    npd: 'all',
    databrain: 'all',
  },
});

const CONSOLE_METRICS_TABLE_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'mutilMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'cascader',
    children: getMetricsChildren(),
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      condition: '!additionalFields:businessType:mobile-rpd',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const CONSOLE_DIGITAL_REVENUE_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      isDefault: true,
      // enumKey指向dataSource中DATA_SOURCE_METRICS的key
      enumKey: 'digitalRevenue',
      enumTargetType: 'metric',
      condition: 'additionalFields:businessType:console-DigitalRevenue',
    }, {
      isDefault: true,
      enumKey: 'units',
      enumTargetType: 'metric',
      condition: 'additionalFields:businessType:console-DigitalRevenue',
    }, {
      isDefault: true,
      enumKey: 'digitalARPPU',
      enumTargetType: 'metric',
      condition: 'additionalFields:businessType:console-DigitalRevenue',
    }, {
      isDefault: true,
      enumKey: 'ast',
      enumTargetType: 'metric',
      condition: 'additionalFields:businessType:console-DigitalRevenue',
    }],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      label: 'Segment Settings',
      labelKey: 'dbi_label_segment_settings',
      value: 'special_segmentSettings',
      enumTargetType: 'segment',
      type: 'checkboxGroup',
      children: [{
        isDefault: true,
        enumKey: 'fullGame',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'dlcAllOther',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'dlcExpansion',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'dlcSeasonPass',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'dlcBattlePass',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'mtx',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'subscription',
        enumTargetType: 'segment',
      }],
    }, {
      enumKey: 'special_platformSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'checkboxGroup',
      children: [{
        isDefault: true,
        enumKey: 'playstation',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xbox',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'nintendo',
        enumTargetType: 'platformPC',
      }]
    }, {
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const CONSOLE_UNIVERSAL_DOWNLOAD_SET: IChildProp[] =
  [{
  // Famitsu is temporarily unavailable in Intelligence pages.
  // {
  //   enumKey: 'metrics',
  //   enumTargetType: 'downloadMainCategory',
  //   type: 'checkboxGroup',
  //   condition: 'additionalFields:businessType:topcharts-console-japan-sales',
  //   children: [{
  //     isDefault: true,
  //     enumKey: 'famitsu_salesOfSelectedTime$',
  //     enumTargetType: 'metric',
  //     isNoIcon: true,
  //   }, {
  //     isDefault: true,
  //     enumKey: 'famitsu_priceFamitsu_console',
  //     enumTargetType: 'metric',
  //     isNoIcon: true,
  //   }, {
  //     isDefault: true,
  //     enumKey: 'famitsu_revenueOfSelectedTime$',
  //     enumTargetType: 'metric',
  //     isNoIcon: true,
  //   }, {
  //     isDefault: true,
  //     enumKey: 'famitsu_cumulativeSalesOfTheLatestWeek',
  //     enumTargetType: 'metric',
  //     isNoIcon: true,
  //   }, {
  //     isDefault: true,
  //     enumKey: 'famitsu_cumulativeRevenueOfTheLatestWeek',
  //     enumTargetType: 'metric',
  //     isNoIcon: true,
  //   }],
  // },
  // {
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    condition: '!additionalFields:businessType:topcharts-console-japan-sales',
    children: [{
      isDefault: true,
      enumKey: 'physicalRevenue',
      enumTargetType: 'metric',
      isNoIcon: true,
      condition: 'additionalFields:businessType:console-PhysicalRevenue',
    }, {
      isDefault: true,
      enumKey: 'physicalUnits',
      enumTargetType: 'metric',
      isNoIcon: true,
      condition: 'additionalFields:businessType:console-PhysicalRevenue',
    }, {
      isDefault: true,
      enumKey: 'mau',
      enumTargetType: 'metric',
      isNoIcon: true,
      condition: 'additionalFields:businessType:console-MAU',
    }, {
      isDefault: true,
      enumKey: 'acquisition',
      enumTargetType: 'metric',
      isNoIcon: true,
      condition: 'additionalFields:businessType:console-MAU',
    }],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'special_platformSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'checkboxGroup',
      condition: 'additionalFields:businessType:console-PhysicalRevenue||additionalFields:businessType:console-MAU',
      children: [{
        isDefault: true,
        enumKey: 'playStation4',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'playStation5',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xboxOne',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xboxSeriesxs',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'nintendoSwitch',
        enumTargetType: 'platformPC',
        condition: 'additionalFields:businessType:console-PhysicalRevenue',
      }, {
        isDefault: true,
        enumKey: 'nintendoWiiU',
        enumTargetType: 'platformPC',
        condition: 'additionalFields:businessType:console-PhysicalRevenue',
      }]
    }, {
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      children: [{
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
      condition: '!additionalFields:businessType:topcharts-console-japan-sales',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const CONSOLE_OHTERS_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'text',
    condition: 'additionalFields:businessType:console-LifeTimePlayers',
    children: [{
      isDefault: true,
      enumKey: 'lifetimePlayer',
      enumTargetType: 'metric',
    }],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    condition: 'additionalFields:businessType:console-LifeTimePlayers',
    children: [{
      enumKey: 'special_platformSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'checkboxGroup',
      children: [{
        isDefault: true,
        enumKey: 'playStation4',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'playStation5',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xboxOne',
        enumTargetType: 'platformPC',
      }, {
        isDefault: true,
        enumKey: 'xboxSeriesxs',
        enumTargetType: 'platformPC',
      }]
    }, {
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      children: [{
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

export default {
  consoleMetricsTable: CONSOLE_METRICS_TABLE_DOWNLOAD_SET,
  consoleDigitalRevenue: CONSOLE_DIGITAL_REVENUE_DOWNLOAD_SET,
  consoleUniversal: CONSOLE_UNIVERSAL_DOWNLOAD_SET,
  consoleOthers: CONSOLE_OHTERS_DOWNLOAD_SET
};
